import { createSlice, createAsyncThunk  } from '@reduxjs/toolkit';
import UserService from "../../services/user-service";

const initialState = {
    loading: false,
    users: [],
    error: ''
}

export const fetchCustomerById = createAsyncThunk('singleUser/fetchCustomerById', async (id) => {
    const response = await UserService.getCustomerById(id);
    return response.data;
})

const customerByIdSlice = createSlice({
    name: 'singleUser',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchCustomerById.pending, state => {
            state.loading = true
        })
        builder.addCase(fetchCustomerById.fulfilled, (state, action) => {
            state.loading = false
            state.users = action.payload
            state.error = ''
        })
        builder.addCase(fetchCustomerById.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = action.error.message
        })
    }
})

export default customerByIdSlice.reducer